var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"vertical-space"},[_c('b-tabs',{attrs:{"content-class":"my-3"}},[_c('b-tab',{attrs:{"title":_vm.t('multiadd_title'),"active":""}},[_c('Multiadd')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }